import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-compute-to-data-panel',
  templateUrl: './compute-to-data-panel.component.html',
  styleUrls: ['./compute-to-data-panel.component.scss']
})
export class ComputeToDataPanelComponent {
  selectedAlgorithm = 'delay-risk';
  isRunning = false;
  showResult = false;
  processingLabel = '';

  runAnalysis(): void {
    this.isRunning = true;
    this.showResult = false;
    this.processingLabel = 'Secure Processing wird beim Provider-Connector gestartet...';

    setTimeout(() => {
      this.processingLabel = 'Aggregation wird ausgefuehrt. Rohdaten verlassen den Anbieter nicht...';
    }, 900);

    setTimeout(() => {
      this.isRunning = false;
      this.showResult = true;
      this.processingLabel = '';
    }, 2400);
  }
}
